import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
let SocialSharing = require('vue-social-sharing');

Vue.use(SocialSharing);
Vue.config.productionTip = false;

async function initData() {
  try {
    if (localStorage && localStorage.getItem('user') && localStorage.getItem('token')) {
      await store.dispatch('initData');
    }
  } catch (e) {
    if (localStorage) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  } finally {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App)
    }).$mount('#app');
  }
}

initData();

